module.exports = __webpack_public_path__ + "img/jdrpx_icon.d245bee7.png";